// before 20-5-2026


// import React, { useEffect, useState, useMemo } from 'react';
// import { Card, Col, Container, Row, ProgressBar, Spinner } from 'react-bootstrap';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useNavigate } from 'react-router-dom';
// import {
//   AccessibilityNew as AccessibilityNewIcon,
//   TipsAndUpdates as TipsAndUpdatesIcon,
//   Bookmark as BookmarkIcon,
//   AccessTimeFilled as AccessTimeFilledIcon,
//   AccessAlarm as AccessAlarmIcon,
//   TaskAlt as TaskAltIcon,
//   PhonelinkErase as PhonelinkEraseIcon,
//   ThumbUp as ThumbUpIcon,
//   Cancel as CancelIcon,
//   WorkHistory as WorkHistoryIcon,
//   Backspace as BackspaceIcon,
//   ArrowForward as ArrowForwardIcon,
//   ShowChart as ShowChartIcon,
//   TrendingUp as TrendingUpIcon,
//   People as PeopleIcon,
//   Dashboard as DashboardIcon,
//   BarChart as BarChartIcon,
//   Celebration as CelebrationIcon,
//   PendingActions as PendingActionsIcon,
// } from '@mui/icons-material';
// import { Doughnut } from 'react-chartjs-2';
// import {
//   Chart as ChartJS,
//   ArcElement,
//   Tooltip,
//   Legend,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Filler,
// } from 'chart.js';
// import LinearProgress from '@mui/material/LinearProgress';
// import Box from '@mui/material/Box';
// import Button from '@mui/material/Button';
// import ContactMailIcon from '@mui/icons-material/ContactMail';
// import { Getteamleaderdashboarddatabyteamleaderemailadvanced } from '../Redux/Actions/RoleData_Actions';
// import { useTheme } from '@mui/material';
// import { DashbordPerformanceForAllUsers } from './DashbordPerformanceForAllUsers';

// // Register ChartJS components
// ChartJS.register(
//   ArcElement,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
//   Filler,
// );

// export const TeamLeaderDashboard = ({ darkMode = false }) => {
//   const theme = useTheme();
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const mode = theme.palette.mode;

//   const [userlogin, setUserLogin] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [loadingProgress, setLoadingProgress] = useState(0);
//   const [dataLoading, setDataLoading] = useState(false); // ✅ جديد: حالة تحميل البيانات
//   const [dataLoadingProgress, setDataLoadingProgress] = useState(0); // ✅ جديد: تقدم تحميل البيانات

//   useEffect(() => {
//     const user = JSON.parse(localStorage.getItem('user'));
//     if (user) setUserLogin(user);
//   }, []);

//   // محاكاة تقدم التحميل الأولي
//   useEffect(() => {
//     if (loading) {
//       const interval = setInterval(() => {
//         setLoadingProgress((oldProgress) => {
//           if (oldProgress >= 90) {
//             clearInterval(interval);
//             return 90;
//           }
//           return Math.min(oldProgress + 10, 90);
//         });
//       }, 300);

//       return () => clearInterval(interval);
//     } else {
//       setLoadingProgress(100);
//       setTimeout(() => setLoadingProgress(0), 500);
//     }
//   }, [loading]);

//   // ✅ جديد: محاكاة تقدم تحميل البيانات
//   useEffect(() => {
//     if (dataLoading) {
//       const interval = setInterval(() => {
//         setDataLoadingProgress((oldProgress) => {
//           if (oldProgress >= 85) {
//             clearInterval(interval);
//             return 85;
//           }
//           return Math.min(oldProgress + 5, 85);
//         });
//       }, 200);

//       return () => clearInterval(interval);
//     } else {
//       setDataLoadingProgress(100);
//       setTimeout(() => {
//         setDataLoadingProgress(0);
//       }, 300);
//     }
//   }, [dataLoading]);

//   // تعريف الأيقونات مع ألوان موحدة
//   const stagesIcons = {
//     Fresh: <TipsAndUpdatesIcon fontSize="large" />,
//     'No Stage': <TipsAndUpdatesIcon fontSize="large" />,
//     'Team Leader Fresh': <TipsAndUpdatesIcon fontSize="large" />,
//     'Team Leader Pending': <PendingActionsIcon fontSize="large" />,
//     Pending: <PendingActionsIcon fontSize="large" />,
//     Follow: <BookmarkIcon fontSize="large" />,
//     'Follow Up': <BookmarkIcon fontSize="large" />,
//     'Long Follow': <BookmarkIcon fontSize="large" />,
//     Transfer: <BackspaceIcon fontSize="large" />,
//     Interested: <ThumbUpIcon fontSize="large" />,
//     'Not Interested': <BackspaceIcon fontSize="large" />,
//     Meeting: <AccessTimeFilledIcon fontSize="large" />,
//     'Following After Meeting': <WorkHistoryIcon fontSize="large" />,
//     'Follow After Meeting': <WorkHistoryIcon fontSize="large" />,
//     'Cancel Meeting': <CancelIcon fontSize="large" />,
//     'Done Deal': <TaskAltIcon fontSize="large" />,
//     'No Answer': <PhonelinkEraseIcon fontSize="large" />,
//     'No Answer 1st Call': <AccessAlarmIcon fontSize="large" />,
//     Cancellation: <CancelIcon fontSize="large" />,
//   };

//   // ✅ استدعاء API الجديد مع إضافة شريط تحميل البيانات
//   const fetchDashboardData = async () => {
//     try {
//       setDataLoading(true); // ✅ تشغيل شريط تحميل البيانات
//       setDataLoadingProgress(10);

//       if (userlogin?.data?.email) {
//         await dispatch(Getteamleaderdashboarddatabyteamleaderemailadvanced(userlogin.data.email));

//         // محاكاة تقدم إضافي بعد اكتمال الطلب
//         setDataLoadingProgress(95);
//         setTimeout(() => {
//           setDataLoadingProgress(100);
//           setTimeout(() => {
//             setDataLoading(false); // ✅ إيقاف شريط تحميل البيانات
//             setDataLoadingProgress(0);
//           }, 300);
//         }, 500);
//       }
//     } catch (error) {
//       console.error('Error fetching dashboard data:', error);
//       setDataLoading(false);
//       setDataLoadingProgress(0);
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (userlogin?.data?.email) {
//       setLoading(true);
//       fetchDashboardData();
//     }
//   }, [userlogin]);

//   // ✅ تصحيح استخراج البيانات من الـredux store
//   const dashboardData = useSelector((state) => state.AllRoleData.teamleaderdashboard);

//   // ✅ البيانات تأتي في dashboardData.data.data لأن الـAPI يرجع {success: true, data: {...}}
//   const dashboard = dashboardData?.data?.dashboard || [];
//   const teamLeaderFresh = dashboardData?.data?.teamLeaderFresh || { leadsCount: 0 };
//   const teamLeaderPending = dashboardData?.data?.teamLeaderPending || {
//     leadsCount: 0,
//     salesIds: [],
//   };
//   const summary = dashboardData?.data?.summary || { totalLeads: 0 };
//   const teamleaderInfo = dashboardData?.data?.teamleaderInfo || {};

//   // ✅ تحديث حالة التحميل عندما تكون البيانات متوفرة
//   useEffect(() => {
//     if (dashboardData && !dataLoading) {
//       setLoading(false);
//     }
//   }, [dashboardData, dataLoading]);

//   // ✅ عرض بيانات التصحيح في الكونسول
//   useEffect(() => {
//     if (dashboardData && !loading) {
//       console.log('📊 Dashboard data structure:', {
//         fullData: dashboardData,
//         hasData: !!dashboardData.data,
//         dashboardLength: dashboard.length,
//         freshCount: teamLeaderFresh.leadsCount,
//         pendingCount: teamLeaderPending.leadsCount,
//         totalLeads: summary.totalLeads,
//       });
//     }
//   }, [dashboardData, loading]);

//   // ✅ دالة لترتيب الـ Stages حسب الترتيب المطلوب
//   const getSortedStages = (stages) => {
//     const order = [
//       'Team Leader Pending',
//       'Team Leader Fresh',
//       'No Stage',
//       'Pending',
//       'Interested',
//       'Follow Up',
//       'Meeting',
//       'Follow After Meeting',
//       'Done Deal',
//       'Cancel Meeting',
//       'No Answer',
//       'Not Interested',
//       'Transfer',
//       'Long Follow',
//       'Follow',
//       'Following After Meeting',
//       'No Answer 1st Call',
//       'Cancellation',
//     ];

//     // فلترة: إخفاء Fresh الأصلي إذا كان موجوداً في dashboard العادية
//     const filteredStages = stages.filter(
//       (stage) =>
//         stage.stageName !== 'Fresh' &&
//         stage.stageName !== 'Team Leader Fresh' &&
//         stage.stageName !== 'Team Leader Pending',
//     );

//     return [...filteredStages].sort((a, b) => {
//       const indexA = order.indexOf(a.stageName);
//       const indexB = order.indexOf(b.stageName);

//       if (indexA !== -1 && indexB !== -1) {
//         return indexA - indexB;
//       }

//       if (indexA !== -1) return -1;
//       if (indexB !== -1) return 1;

//       return 0;
//     });
//   };

//   // ✅ إضافة المراحل الخاصة للـdashboard بالترتيب المطلوب
//   const allStages = useMemo(() => {
//     let stages = [...dashboard];

//     // فلترة: إخفاء Fresh الأصلي
//     stages = stages.filter((stage) => stage.stageName !== 'Fresh');

//     // إضافة المراحل الخاصة بالترتيب المطلوب
//     const specialStages = [];

//     // 1. Team Leader Pending أولاً
//     if (teamLeaderPending.leadsCount > 0 || true) {
//       specialStages.push({
//         stageId: teamLeaderPending.stageId || 'team-leader-pending',
//         stageName: 'Team Leader Pending',
//         leadsCount: teamLeaderPending.leadsCount,
//         isTeamLeaderPending: true,
//         salesIds: teamLeaderPending.salesIds || [],
//       });
//     }

//     // 2. Team Leader Fresh ثانياً
//     if (teamLeaderFresh.leadsCount > 0 || true) {
//       specialStages.push({
//         stageId: teamLeaderFresh.stageId || 'team-leader-fresh',
//         stageName: 'Team Leader Fresh',
//         leadsCount: teamLeaderFresh.leadsCount,
//         isTeamLeaderFresh: true,
//       });
//     }

//     // 3. المراحل العادية بعد ذلك
//     const regularStages = getSortedStages(stages);

//     return [...specialStages, ...regularStages];
//   }, [dashboard, teamLeaderFresh, teamLeaderPending]);

//   // ✅ حساب إجمالي الـ Leads
//   const totalLeads = summary.totalLeads || 0;

//   // ✅ دالة التعامل مع النقر على مرحلة
//   const handleStageClick = async (stage) => {
//     const { stageName, isTeamLeaderFresh, isTeamLeaderPending } = stage;

//     console.log('🎯 Stage clicked:', stageName);

//     // 🔥 تنظيف شامل للـ localStorage
//     const allKeysToRemove = [
//       'teamLeaderFreshMode',
//       'teamLeaderPendingMode',
//       'teamLeaderPendingSalesId',
//       'teamleaderfresh',
//       'teamleaderId',
//       'filterForSales',
//       'teamleaderpending',
//       'stagestorage',
//       'FilteredLeadsForNoStage',
//       'FilteredLeadsForTeamLeaderPending',
//       'freshFilterType',
//     ];

//     allKeysToRemove.forEach((key) => localStorage.removeItem(key));

//     if (isTeamLeaderFresh) {
//       try {
//         const teamLeaderId =
//           teamLeaderPending.salesIds?.[0] || teamleaderInfo._id || userlogin?.data?._id || '';

//         console.log('✅ Team Leader ID for Fresh:', teamLeaderId);
//         console.log('📊 Team Leader Info:', teamleaderInfo);

//         if (!teamLeaderId) {
//           console.error('❌ User ID not found');
//           alert('Unable to identify team leader. Please log in again.');
//           return;
//         }

//         const queryParams = new URLSearchParams({
//           stage: 'No Stage',
//           sales: teamLeaderId,
//           teamleaderfresh: 'true',
//           freshmode: 'teamleader',
//         });

//         console.log('📤 Query params for Team Leader Fresh:', queryParams.toString());

//         localStorage.setItem('stagestorage', 'No Stage');
//         localStorage.setItem('filterForSales', teamLeaderId);
//         localStorage.setItem('teamleaderId', teamLeaderId);
//         localStorage.setItem('teamleaderfresh', 'true');
//         localStorage.setItem('teamLeaderFreshMode', 'true');
//         localStorage.setItem('freshFilterType', 'teamleader');

//         const url = `/AllLeadsForTeamLeader?${queryParams.toString()}`;
//         console.log('🚀 Navigating to Team Leader Fresh:', url);

//         navigate(url);
//       } catch (error) {
//         console.error('❌ Error in Team Leader Fresh navigation:', error);

//         localStorage.setItem('stagestorage', 'No Stage');
//         localStorage.setItem('teamleaderfresh', 'true');
//         localStorage.setItem('teamLeaderFreshMode', 'true');

//         navigate(`/AllLeadsForTeamLeader?stage=No Stage&teamleaderfresh=true`);
//       }
//     } else if (isTeamLeaderPending) {
//       const teamLeaderId =
//         teamLeaderPending.salesIds?.[0] || teamleaderInfo._id || userlogin?.data?._id || '';

//       console.log('✅ Team Leader Pending ID:', teamLeaderId);

//       allKeysToRemove.forEach((key) => localStorage.removeItem(key));

//       localStorage.setItem('stagestorage', 'Pending');
//       localStorage.setItem('teamleaderpending', 'true');
//       localStorage.setItem('filterForSales', teamLeaderId);
//       localStorage.setItem('teamLeaderPendingMode', 'true');
//       localStorage.setItem('teamLeaderPendingSalesId', teamLeaderId);

//       const queryParams = new URLSearchParams({
//         stage: 'Pending',
//         sales: teamLeaderId,
//         teamleaderpending: 'true',
//         pendingmode: 'teamleader',
//       });

//       console.log('📤 Pending query params:', queryParams.toString());

//       navigate(`/AllLeadsForTeamLeader?${queryParams.toString()}`);
//     } else if (stageName === 'All Leads') {
//       allKeysToRemove.forEach((key) => localStorage.removeItem(key));
//       localStorage.setItem('stagestorage', '');

//       navigate(`/AllLeadsForTeamLeader`);
//     } else {
//       allKeysToRemove.forEach((key) => localStorage.removeItem(key));

//       localStorage.setItem('stagestorage', stageName);

//       if (stageName === 'No Stage') {
//         navigate(`/AllLeadsForTeamLeader?stage=${encodeURIComponent(stageName)}&mode=all`);
//       } else {
//         navigate(`/AllLeadsForTeamLeader?stage=${encodeURIComponent(stageName)}`);
//       }
//     }
//   };

//   // 🔥 تعريف اللون الموحد
//   const UNIFIED_COLOR = '#118AB2';

//   // ✅ إعداد بيانات الرسم البياني
//   const getStageChartData = useMemo(() => {
//     const labels = allStages.map((stage) => stage.stageName);
//     const data = allStages.map((stage) => stage.leadsCount);

//     const backgroundColors = labels.map((label) => {
//       if (label === 'Team Leader Pending') return '#4CAF50';
//       if (label === 'Team Leader Fresh') return '#4CAF50';
//       if (label === 'Done Deal' || label === 'Not Interested' || label === 'Cancel Meeting')
//         return '#F44336';
//       return UNIFIED_COLOR;
//     });

//     return {
//       labels: labels,
//       datasets: [
//         {
//           data,
//           backgroundColor: backgroundColors,
//           borderColor: mode === 'dark' ? '#1a1a2e' : '#ffffff',
//           borderWidth: 2,
//           hoverOffset: 15,
//           hoverBorderWidth: 3,
//         },
//       ],
//     };
//   }, [allStages, mode]);

//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         position: 'right',
//         labels: {
//           color: mode === 'dark' ? '#fff' : '#333',
//           font: {
//             size: 11,
//             family: 'Heebo, sans-serif',
//           },
//           padding: 20,
//           usePointStyle: true,
//           pointStyle: 'circle',
//         },
//       },
//       tooltip: {
//         backgroundColor: mode === 'dark' ? 'rgba(0,0,0,0.8)' : 'rgba(255,255,255,0.9)',
//         titleColor: mode === 'dark' ? '#fff' : '#333',
//         bodyColor: mode === 'dark' ? '#fff' : '#333',
//         borderColor: UNIFIED_COLOR,
//         borderWidth: 1,
//         callbacks: {
//           label: function (context) {
//             const label = context.label || '';
//             const value = context.raw || 0;
//             const total = context.dataset.data.reduce((a, b) => a + b, 0);
//             const percentage = total > 0 ? Math.round((value / total) * 100) : 0;
//             return `${label}: ${value} leads (${percentage}%)`;
//           },
//         },
//       },
//     },
//     cutout: '60%',
//   };

//   // ✅ شريط التحميل في الأعلى (للصفحة)
//   const LoadingBar = () => (
//     <Box
//       sx={{
//         width: '100%',
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         zIndex: 9999,
//       }}
//     >
//       <LinearProgress
//         variant="determinate"
//         value={loadingProgress}
//         sx={{
//           height: 4,
//           backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//           '& .MuiLinearProgress-bar': {
//             backgroundColor: UNIFIED_COLOR,
//             transition: 'transform 0.4s linear',
//           },
//         }}
//       />
//     </Box>
//   );

//   // ✅ جديد: شريط تحميل البيانات
//   const DataLoadingBar = () => (
//     <Box
//       sx={{
//         width: '100%',
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         zIndex: 9998,
//       }}
//     >
//       <LinearProgress
//         variant="determinate"
//         value={dataLoadingProgress}
//         sx={{
//           height: 3,
//           backgroundColor: 'transparent',
//           '& .MuiLinearProgress-bar': {
//             backgroundColor: '#4CAF50',
//             backgroundImage:
//               'linear-gradient(45deg, rgba(255,255,255,0.3) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.3) 50%, rgba(255,255,255,0.3) 75%, transparent 75%, transparent)',
//             backgroundSize: '20px 20px',
//             animation: 'move 2s linear infinite',
//           },
//         }}
//       />
//     </Box>
//   );

//   // ✅ جديد: عرض حالة تحميل البيانات
//   const DataLoadingOverlay = () => (
//     <Box
//       sx={{
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         width: '100%',
//         height: '100%',
//         backgroundColor: mode === 'dark' ? 'rgba(0,0,0,0.85)' : 'rgba(255,255,255,0.9)',
//         display: dataLoading ? 'flex' : 'none',
//         flexDirection: 'column',
//         justifyContent: 'center',
//         alignItems: 'center',
//         zIndex: 9997,
//         backdropFilter: 'blur(5px)',
//       }}
//     >
//       <Box sx={{ width: '80%', maxWidth: '400px', textAlign: 'center' }}>
//         {/* رسالة التحذير */}
//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             mb: 3,
//           }}
//         >
//           <DashboardIcon
//             sx={{
//               fontSize: 40,
//               color: UNIFIED_COLOR,
//               mr: 2,
//               animation: 'pulse 1.5s infinite',
//             }}
//           />
//           <Box>
//             <h3
//               style={{
//                 color: mode === 'dark' ? '#fff' : '#333',
//                 margin: 0,
//                 fontWeight: 'bold',
//               }}
//             >
//               Loading Dashboard Data
//             </h3>
//             <p
//               style={{
//                 color: mode === 'dark' ? '#ccc' : '#666',
//                 margin: '5px 0 0 0',
//                 fontSize: '0.9rem',
//               }}
//             >
//               Please wait while we fetch your statistics...
//             </p>
//           </Box>
//         </Box>

//         {/* شريط التقدم الرئيسي */}
//         <Box sx={{ width: '100%', mb: 2 }}>
//           <LinearProgress
//             variant="determinate"
//             value={dataLoadingProgress}
//             sx={{
//               height: 8,
//               borderRadius: 4,
//               backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//               '& .MuiLinearProgress-bar': {
//                 borderRadius: 4,
//                 background: `linear-gradient(90deg, ${UNIFIED_COLOR} 0%, #4a9ddd 100%)`,
//                 transition: 'transform 0.4s linear',
//               },
//             }}
//           />
//         </Box>

//         {/* تفاصيل التحميل */}
//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             width: '100%',
//             mt: 1,
//           }}
//         >
//           <span
//             style={{
//               color: mode === 'dark' ? '#aaa' : '#777',
//               fontSize: '0.8rem',
//             }}
//           >
//             {dataLoadingProgress < 30
//               ? 'Initializing...'
//               : dataLoadingProgress < 60
//                 ? 'Fetching data...'
//                 : dataLoadingProgress < 90
//                   ? 'Processing...'
//                   : 'Almost done...'}
//           </span>
//           <span
//             style={{
//               color: UNIFIED_COLOR,
//               fontSize: '0.8rem',
//               fontWeight: 'bold',
//             }}
//           >
//             {Math.round(dataLoadingProgress)}%
//           </span>
//         </Box>

//         {/* مؤشر تحميل متحرك */}
//         <Box sx={{ mt: 4 }}>
//           <div
//             className="spinner-border"
//             style={{
//               color: UNIFIED_COLOR,
//               width: '2rem',
//               height: '2rem',
//             }}
//             role="status"
//           >
//             <span className="visually-hidden">Loading...</span>
//           </div>
//         </Box>
//       </Box>
//     </Box>
//   );

//   // ✅ عرض حالة التحميل الرئيسية
//   if (loading && !dashboardData) {
//     return (
//       <>
//         <LoadingBar />
//         <div
//           style={{
//             background:
//               mode === 'dark'
//                 ? 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 100%)'
//                 : 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
//             minHeight: '100vh',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//           }}
//         >
//           <div className="text-center">
//             <div className="spinner-border text-primary" role="status">
//               <span className="visually-hidden">Loading...</span>
//             </div>
//             <p className="mt-3" style={{ color: mode === 'dark' ? '#fff' : '#333' }}>
//               Loading dashboard...
//             </p>
//           </div>
//         </div>
//       </>
//     );
//   }

//   return (
//     <div
//       style={{
//         background:
//           mode === 'dark'
//             ? 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 100%)'
//             : 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
//         minHeight: '100vh',
//         fontFamily: '"Heebo", "Segoe UI", sans-serif',
//         opacity: dataLoading ? 0.7 : 1, // ✅ تخفيف الصفحة أثناء تحميل البيانات
//         transition: 'opacity 0.3s ease',
//       }}
//     >
//       {/* شريط التحميل الأولي */}
//       {loading && <LoadingBar />}

//       {/* ✅ جديد: شريط تحميل البيانات */}
//       {dataLoading && <DataLoadingBar />}

//       {/* ✅ جديد: طبقة تحميل البيانات */}
//       <DataLoadingOverlay />

//       <Container className="py-4" style={{ marginTop: '80px' }}>
//         {/* ✅ قسم الترحيب */}
//         <div className="welcome-section mb-5 text-center">
//           <div className="position-relative">
//             <DashboardIcon
//               sx={{
//                 fontSize: 80,
//                 color: mode === 'dark' ? 'rgba(16, 45, 255, 0.3)' : 'rgba(16, 45, 255, 0.1)',
//                 position: 'absolute',
//                 top: '-20px',
//                 left: '50%',
//                 transform: 'translateX(-50%)',
//                 zIndex: 0,
//               }}
//             />
//             <h2
//               className="fw-bold heebo-bold position-relative"
//               style={{
//                 color: '#102dff',
//                 fontSize: '2.2rem',
//                 textShadow:
//                   mode === 'dark' ? '0 2px 4px rgba(0,0,0,0.3)' : '0 2px 4px rgba(0,0,0,0.1)',
//                 zIndex: 1,
//               }}
//             >
//               Welcome to Dashboard / {teamleaderInfo.name || userlogin?.data?.name}
//             </h2>
//             <p
//               className="mt-2"
//               style={{
//                 fontSize: '1.1rem',
//                 color: mode === 'dark' ? '#aaa' : '#666',
//                 maxWidth: '600px',
//                 margin: '0 auto',
//               }}
//             >
//               Manage your team's leads and track performance
//               {dashboardData?.data?.meta && (
//                 <small className="d-block mt-1" style={{ fontSize: '0.9rem' }}>
//                   Data loaded in {dashboardData.data.meta.executionTime} •
//                   {dashboardData.data.meta.fromCache ? ' Cached' : ' Fresh'}
//                 </small>
//               )}
//             </p>
//           </div>
//         </div>

//         {/* 📊 قسم الإحصائيات السريعة */}
//         <Row className="mb-5">
//           <Col xs={12} className="mb-4">
//             <div className="d-flex align-items-center justify-content-between">
//               <div className="d-flex align-items-center">
//                 <ShowChartIcon sx={{ color: UNIFIED_COLOR, mr: 1 }} />
//                 <h4 className="mb-0 fw-bold" style={{ color: mode === 'dark' ? '#fff' : '#333' }}>
//                   Quick Numbers
//                 </h4>
//               </div>

//               {/* زر CRM Data */}
//               <Link
//                 to="/TeamLeaderQuickNumbersCRMData"
//                 style={{
//                   textDecoration: 'none',
//                   display: 'inline-flex',
//                 }}
//               >
//                 <Button
//                   variant="outlined"
//                   startIcon={<ContactMailIcon />}
//                   sx={{
//                     color: UNIFIED_COLOR,
//                     borderColor: UNIFIED_COLOR,
//                     '&:hover': {
//                       backgroundColor: UNIFIED_COLOR,
//                       color: '#fff',
//                       borderColor: UNIFIED_COLOR,
//                     },
//                   }}
//                 >
//                   CRM Data
//                 </Button>
//               </Link>
//             </div>
//           </Col>

//           {/* زر All Leads */}
//           <Col xs={12} md={4} className="mb-4">
//             <div
//               className="dashboard-card shadow-lg"
//               style={{
//                 background:
//                   mode === 'dark'
//                     ? 'linear-gradient(135deg, #1e1e2e 0%, #2d2d44 100%)'
//                     : 'linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)',
//                 border: 'none',
//                 borderRadius: '20px',
//                 overflow: 'hidden',
//                 cursor: 'pointer',
//                 transition: 'all 0.3s ease',
//                 height: '100%',
//                 borderLeft: `5px solid ${UNIFIED_COLOR}`,
//               }}
//               onClick={() => handleStageClick({ stageName: 'All Leads' })}
//               onMouseEnter={(e) => {
//                 e.currentTarget.style.transform = 'translateY(-5px)';
//                 e.currentTarget.style.boxShadow = `0 10px 25px ${UNIFIED_COLOR}33`;
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.transform = 'translateY(0)';
//                 e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
//               }}
//             >
//               <div className="text-center p-4">
//                 <div className="mb-3">
//                   <div
//                     style={{
//                       width: '70px',
//                       height: '70px',
//                       background: `linear-gradient(135deg, ${UNIFIED_COLOR} 0%, #4a9ddd 100%)`,
//                       borderRadius: '50%',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       margin: '0 auto',
//                     }}
//                   >
//                     <PeopleIcon sx={{ color: '#fff', fontSize: 35 }} />
//                   </div>
//                 </div>
//                 <h5 className="fw-bold mb-2" style={{ color: mode === 'dark' ? '#ccc' : '#666' }}>
//                   All Leads
//                 </h5>
//                 <h1 className="fw-bold display-6" style={{ color: UNIFIED_COLOR }}>
//                   {totalLeads}
//                 </h1>
//                 <small style={{ color: mode === 'dark' ? '#aaa' : '#888' }}>
//                   View all leads in your team
//                 </small>
//               </div>
//             </div>
//           </Col>

//           {/* كارت Team Leader Pending */}
//           <Col xs={12} md={4} className="mb-4">
//             <div
//               className="dashboard-card shadow-lg"
//               style={{
//                 background:
//                   mode === 'dark'
//                     ? 'linear-gradient(135deg, #1e1e2e 0%, #2d2d44 100%)'
//                     : 'linear-gradient(135deg, #ffffff 0%, #fff8f0 100%)',
//                 border: 'none',
//                 borderRadius: '20px',
//                 overflow: 'hidden',
//                 cursor: 'pointer',
//                 transition: 'all 0.3s ease',
//                 height: '100%',
//                 borderLeft: `5px solid #4CAF50`,
//               }}
//               onClick={() =>
//                 handleStageClick({
//                   stageName: 'Team Leader Pending',
//                   isTeamLeaderPending: true,
//                   leadsCount: teamLeaderPending.leadsCount,
//                   salesIds: teamLeaderPending.salesIds,
//                 })
//               }
//               onMouseEnter={(e) => {
//                 e.currentTarget.style.transform = 'translateY(-5px)';
//                 e.currentTarget.style.boxShadow = `0 10px 25px rgba(255, 152, 0, 0.2)`;
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.transform = 'translateY(0)';
//                 e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
//               }}
//             >
//               <div className="text-center p-4">
//                 <div className="mb-3">
//                   <div
//                     style={{
//                       width: '70px',
//                       height: '70px',
//                       background: `linear-gradient(135deg, #FF9800 0%, #4CAF50 100%)`,
//                       borderRadius: '50%',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       margin: '0 auto',
//                     }}
//                   >
//                     <PendingActionsIcon sx={{ color: '#fff', fontSize: 35 }} />
//                   </div>
//                 </div>
//                 <h5 className="fw-bold mb-2" style={{ color: mode === 'dark' ? '#ccc' : '#666' }}>
//                   Team Leader Pending
//                 </h5>
//                 <h1 className="fw-bold display-6" style={{ color: '#4CAF50' }}>
//                   {teamLeaderPending.leadsCount || 0}
//                 </h1>
//                 <div className="mt-2">
//                   {totalLeads > 0 && (
//                     <div>
//                       <small style={{ color: mode === 'dark' ? '#aaa' : '#888' }}>
//                         Pending Leads:{' '}
//                         {((teamLeaderPending.leadsCount / totalLeads) * 100).toFixed(1)}%
//                       </small>
//                       <ProgressBar
//                         now={(teamLeaderPending.leadsCount / totalLeads) * 100}
//                         style={{
//                           height: '8px',
//                           borderRadius: '4px',
//                           marginTop: '5px',
//                           backgroundColor:
//                             mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                         }}
//                       />
//                     </div>
//                   )}
//                 </div>
//                 <small
//                   style={{
//                     color: mode === 'dark' ? '#aaa' : '#888',
//                     fontSize: '0.8rem',
//                     marginTop: '10px',
//                     display: 'block',
//                   }}
//                 >
//                   Pending leads assigned to you
//                 </small>
//               </div>
//             </div>
//           </Col>

//           {/* كارت Team Leader Fresh */}
//           <Col xs={12} md={4} className="mb-4">
//             <div
//               className="dashboard-card shadow-lg"
//               style={{
//                 background:
//                   mode === 'dark'
//                     ? 'linear-gradient(135deg, #1e1e2e 0%, #2d2d44 100%)'
//                     : 'linear-gradient(135deg, #ffffff 0%, #f0fff7 100%)',
//                 border: 'none',
//                 borderRadius: '20px',
//                 overflow: 'hidden',
//                 cursor: 'pointer',
//                 transition: 'all 0.3s ease',
//                 height: '100%',
//                 borderLeft: `5px solid #4CAF50`,
//               }}
//               onClick={() =>
//                 handleStageClick({
//                   stageName: 'Team Leader Fresh',
//                   isTeamLeaderFresh: true,
//                   leadsCount: teamLeaderFresh.leadsCount,
//                 })
//               }
//               onMouseEnter={(e) => {
//                 e.currentTarget.style.transform = 'translateY(-5px)';
//                 e.currentTarget.style.boxShadow = `0 10px 25px rgba(76, 175, 80, 0.2)`;
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.transform = 'translateY(0)';
//                 e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
//               }}
//             >
//               <div className="text-center p-4">
//                 <div className="mb-3">
//                   <div
//                     style={{
//                       width: '70px',
//                       height: '70px',
//                       background: `linear-gradient(135deg, #4CAF50 0%, #81C784 100%)`,
//                       borderRadius: '50%',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       margin: '0 auto',
//                     }}
//                   >
//                     <TipsAndUpdatesIcon sx={{ color: '#fff', fontSize: 35 }} />
//                   </div>
//                 </div>
//                 <h5 className="fw-bold mb-2" style={{ color: mode === 'dark' ? '#ccc' : '#666' }}>
//                   Team Leader Fresh
//                 </h5>
//                 <h1 className="fw-bold display-6" style={{ color: '#4CAF50' }}>
//                   {teamLeaderFresh.leadsCount || 0}
//                 </h1>
//                 <div className="mt-2">
//                   {totalLeads > 0 && (
//                     <div>
//                       <small style={{ color: mode === 'dark' ? '#aaa' : '#888' }}>
//                         Fresh Leads: {((teamLeaderFresh.leadsCount / totalLeads) * 100).toFixed(1)}%
//                       </small>
//                       <ProgressBar
//                         now={(teamLeaderFresh.leadsCount / totalLeads) * 100}
//                         style={{
//                           height: '8px',
//                           borderRadius: '4px',
//                           marginTop: '5px',
//                           backgroundColor:
//                             mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                         }}
//                       />
//                     </div>
//                   )}
//                 </div>
//                 <small
//                   style={{
//                     color: mode === 'dark' ? '#aaa' : '#888',
//                     fontSize: '0.8rem',
//                     marginTop: '10px',
//                     display: 'block',
//                   }}
//                 >
//                   [Fresh] leads assigned to you
//                 </small>
//               </div>
//             </div>
//           </Col>
//         </Row>

//         {/* 🎯 كروت المراحل المرتبة */}
//         <Row className="mb-5">
//           <Col xs={12}>
//             <div className="mb-4">
//               <div className="d-flex align-items-center mb-2">
//                 <BookmarkIcon
//                   sx={{
//                     mr: 2,
//                     color: UNIFIED_COLOR,
//                     fontSize: '2.8rem',
//                     background: mode === 'dark' ? `${UNIFIED_COLOR}20` : `${UNIFIED_COLOR}10`,
//                     padding: '10px',
//                     borderRadius: '12px',
//                   }}
//                 />
//                 <div>
//                   <h4
//                     className="fw-bold mb-1"
//                     style={{
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       fontSize: '1.4rem',
//                     }}
//                   >
//                     All Stages ({allStages.length})
//                   </h4>
//                   <small
//                     style={{
//                       color: mode === 'dark' ? '#aaa' : '#666',
//                       fontSize: '0.9rem',
//                     }}
//                   >
//                     Click any stage to view its leads
//                   </small>
//                 </div>
//               </div>
//             </div>
//           </Col>

//           {/* كروت جميع المراحل */}
//           {allStages.map((stage) => {
//             const percentage =
//               totalLeads > 0 ? ((stage.leadsCount / totalLeads) * 100).toFixed(1) : 0;

//             let stageColor = UNIFIED_COLOR;
//             if (stage.stageName === 'Team Leader Pending') stageColor = '#4CAF50';
//             if (stage.stageName === 'Team Leader Fresh') stageColor = '#4CAF50';
//             if (
//               stage.stageName === 'Done Deal' ||
//               stage.stageName === 'Not Interested' ||
//               stage.stageName === 'Cancel Meeting'
//             ) {
//               stageColor = '#F44336';
//             }

//             return (
//               <Col
//                 key={stage.stageId || stage.stageName}
//                 xs={12}
//                 sm={6}
//                 md={4}
//                 lg={3}
//                 className="mb-4"
//               >
//                 <div
//                   className="stage-card"
//                   onClick={() => handleStageClick(stage)}
//                   style={{
//                     background: mode === 'dark' ? '#1e1e2e' : '#ffffff',
//                     border:
//                       mode === 'dark' ? `1px solid ${stageColor}20` : `1px solid ${stageColor}10`,
//                     borderRadius: '16px',
//                     cursor: 'pointer',
//                     transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//                     height: '100%',
//                     overflow: 'hidden',
//                     position: 'relative',
//                     boxShadow:
//                       mode === 'dark'
//                         ? '0 4px 12px rgba(0, 0, 0, 0.2)'
//                         : '0 4px 12px rgba(0, 0, 0, 0.05)',
//                   }}
//                   onMouseEnter={(e) => {
//                     e.currentTarget.style.transform = 'translateY(-4px) scale(1.02)';
//                     e.currentTarget.style.boxShadow =
//                       mode === 'dark'
//                         ? `0 12px 24px rgba(0, 0, 0, 0.3), 0 0 0 1px ${stageColor}40`
//                         : `0 12px 24px rgba(0, 0, 0, 0.08), 0 0 0 1px ${stageColor}20`;
//                     e.currentTarget.style.borderColor = `${stageColor}40`;
//                     e.currentTarget.style.background =
//                       mode === 'dark' ? '#222233' : `${stageColor}08`;
//                   }}
//                   onMouseLeave={(e) => {
//                     e.currentTarget.style.transform = 'translateY(0) scale(1)';
//                     e.currentTarget.style.boxShadow =
//                       mode === 'dark'
//                         ? '0 4px 12px rgba(0, 0, 0, 0.2)'
//                         : '0 4px 12px rgba(0, 0, 0, 0.05)';
//                     e.currentTarget.style.borderColor =
//                       mode === 'dark' ? `${stageColor}20` : `${stageColor}10`;
//                     e.currentTarget.style.background = mode === 'dark' ? '#1e1e2e' : '#ffffff';
//                   }}
//                 >
//                   <div
//                     style={{
//                       height: '4px',
//                       background: `linear-gradient(135deg, ${stageColor} 0%, ${stageColor}80 100%)`,
//                       width: '100%',
//                     }}
//                   />

//                   <div className="p-4">
//                     <div className="d-flex align-items-center justify-content-between mb-3">
//                       <div
//                         style={{
//                           width: '44px',
//                           height: '44px',
//                           background: mode === 'dark' ? `${stageColor}20` : `${stageColor}10`,
//                           borderRadius: '12px',
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           border: `1px solid ${stageColor}30`,
//                         }}
//                       >
//                         {React.cloneElement(
//                           stagesIcons[stage.stageName] || <AccessibilityNewIcon />,
//                           {
//                             sx: {
//                               color: stageColor,
//                               fontSize: 22,
//                             },
//                           },
//                         )}
//                       </div>

//                       <div
//                         style={{
//                           background: mode === 'dark' ? `${stageColor}20` : `${stageColor}10`,
//                           padding: '4px 12px',
//                           borderRadius: '20px',
//                           border: `1px solid ${stageColor}30`,
//                         }}
//                       >
//                         <span
//                           style={{
//                             color: stageColor,
//                             fontSize: '0.8rem',
//                             fontWeight: '600',
//                           }}
//                         >
//                           {percentage}%
//                         </span>
//                       </div>
//                     </div>

//                     <h6
//                       className="fw-bold mb-2"
//                       style={{
//                         color: mode === 'dark' ? '#fff' : '#333',
//                         fontSize: '1rem',
//                         lineHeight: '1.4',
//                       }}
//                     >
//                       {stage.stageName}
//                     </h6>

//                     <div className="mb-3">
//                       <div
//                         style={{
//                           fontSize: '2rem',
//                           fontWeight: '700',
//                           color: stageColor,
//                           lineHeight: '1',
//                           marginBottom: '4px',
//                         }}
//                       >
//                         {stage.leadsCount}
//                       </div>
//                       <small
//                         style={{
//                           color: mode === 'dark' ? '#aaa' : '#666',
//                           fontSize: '0.8rem',
//                         }}
//                       >
//                         leads
//                         {stage.isTeamLeaderFresh && ' (assigned to you)'}
//                         {stage.isTeamLeaderPending && ' (your pending)'}
//                       </small>
//                     </div>

//                     <div>
//                       <div className="d-flex justify-content-between mb-1">
//                         <small
//                           style={{
//                             color: mode === 'dark' ? '#888' : '#777',
//                             fontSize: '0.75rem',
//                             fontWeight: '500',
//                           }}
//                         >
//                           Progress
//                         </small>
//                         <small
//                           style={{
//                             color: stageColor,
//                             fontSize: '0.75rem',
//                             fontWeight: '600',
//                           }}
//                         >
//                           {stage.leadsCount} of {totalLeads}
//                         </small>
//                       </div>
//                       <div
//                         style={{
//                           height: '6px',
//                           background:
//                             mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.08)',
//                           borderRadius: '3px',
//                           overflow: 'hidden',
//                           position: 'relative',
//                         }}
//                       >
//                         <div
//                           style={{
//                             width: `${percentage}%`,
//                             height: '100%',
//                             background: `linear-gradient(135deg, ${stageColor} 0%, ${stageColor}80 100%)`,
//                             borderRadius: '3px',
//                             transition: 'width 0.5s ease',
//                           }}
//                         />
//                       </div>
//                     </div>
//                   </div>

//                   <div className="px-4 pb-3">
//                     <div
//                       style={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         padding: '8px',
//                         background: mode === 'dark' ? `${stageColor}20` : `${stageColor}10`,
//                         borderRadius: '8px',
//                         border: `1px solid ${stageColor}30`,
//                         cursor: 'pointer',
//                         transition: 'all 0.2s ease',
//                       }}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleStageClick(stage);
//                       }}
//                       onMouseEnter={(e) => {
//                         e.currentTarget.style.background = stageColor;
//                         e.currentTarget.style.borderColor = stageColor;
//                         const span = e.currentTarget.querySelector('span');
//                         const svg = e.currentTarget.querySelector('svg');
//                         if (span) span.style.color = '#fff';
//                         if (svg) svg.style.color = '#fff';
//                       }}
//                       onMouseLeave={(e) => {
//                         e.currentTarget.style.background =
//                           mode === 'dark' ? `${stageColor}20` : `${stageColor}10`;
//                         e.currentTarget.style.borderColor = `${stageColor}30`;
//                         const span = e.currentTarget.querySelector('span');
//                         const svg = e.currentTarget.querySelector('svg');
//                         if (span) span.style.color = stageColor;
//                         if (svg) svg.style.color = stageColor;
//                       }}
//                     >
//                       <span
//                         style={{
//                           color: stageColor,
//                           fontSize: '0.8rem',
//                           fontWeight: '600',
//                           marginRight: '6px',
//                           transition: 'color 0.2s ease',
//                         }}
//                       >
//                         View Details
//                       </span>
//                       <ArrowForwardIcon
//                         sx={{
//                           color: stageColor,
//                           fontSize: 16,
//                           transition: 'color 0.2s ease',
//                         }}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </Col>
//             );
//           })}
//         </Row>

//         {/* 📊 الرسم البياني للـ Stages */}
//         <Row className="mb-5">
//           <Col xs={12} lg={6} className="mb-4">
//             <div
//               className="shadow-lg"
//               style={{
//                 background:
//                   mode === 'dark'
//                     ? 'linear-gradient(135deg, #1e1e2e 0%, #2d2d44 100%)'
//                     : 'linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)',
//                 border: 'none',
//                 borderRadius: '20px',
//                 overflow: 'hidden',
//                 height: '100%',
//               }}
//             >
//               <div className="p-4">
//                 <div className="mb-4">
//                   <h5 className="fw-bold mb-1" style={{ color: mode === 'dark' ? '#fff' : '#333' }}>
//                     <BarChartIcon sx={{ mr: 1, color: UNIFIED_COLOR }} />
//                     Leads Distribution by Stage
//                   </h5>
//                   <small style={{ color: mode === 'dark' ? '#aaa' : '#666' }}>
//                     Visual breakdown of leads across all stages
//                   </small>
//                 </div>
//                 <div style={{ height: '350px', position: 'relative' }}>
//                   <Doughnut data={getStageChartData} options={chartOptions} />
//                 </div>
//               </div>
//             </div>
//           </Col>

//           {/* 🎯 قائمة المراحل المرتبة */}
//           <Col xs={12} lg={6} className="mb-4">
//             <div
//               className="shadow-lg"
//               style={{
//                 background:
//                   mode === 'dark'
//                     ? 'linear-gradient(135deg, #1e1e2e 0%, #2d2d44 100%)'
//                     : 'linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)',
//                 border: 'none',
//                 borderRadius: '20px',
//                 overflow: 'hidden',
//                 height: '100%',
//               }}
//             >
//               <div className="p-4">
//                 <div className="mb-4">
//                   <h5 className="fw-bold mb-1" style={{ color: mode === 'dark' ? '#fff' : '#333' }}>
//                     <BookmarkIcon sx={{ mr: 1, color: UNIFIED_COLOR }} />
//                     Stages Overview
//                   </h5>
//                   <small style={{ color: mode === 'dark' ? '#aaa' : '#666' }}>
//                     Click any stage to view its leads
//                   </small>
//                 </div>

//                 <div
//                   style={{
//                     maxHeight: '350px',
//                     overflowY: 'auto',
//                     paddingRight: '10px',
//                   }}
//                 >
//                   {allStages.map((stage) => {
//                     const percentage =
//                       totalLeads > 0 ? ((stage.leadsCount / totalLeads) * 100).toFixed(1) : 0;

//                     let stageColor = UNIFIED_COLOR;
//                     if (stage.stageName === 'Team Leader Pending') stageColor = '#4CAF50';
//                     if (stage.stageName === 'Team Leader Fresh') stageColor = '#4CAF50';
//                     if (
//                       stage.stageName === 'Done Deal' ||
//                       stage.stageName === 'Not Interested' ||
//                       stage.stageName === 'Cancel Meeting'
//                     ) {
//                       stageColor = '#F44336';
//                     }

//                     return (
//                       <div
//                         key={stage.stageId || stage.stageName}
//                         className="mb-3 stage-list-card"
//                         onClick={() => handleStageClick(stage)}
//                         style={{
//                           background: mode === 'dark' ? '#2d2d44' : '#ffffff',
//                           border: '1px solid',
//                           borderColor: mode === 'dark' ? '#3d3d5c' : '#e0e0e0',
//                           borderRadius: '12px',
//                           cursor: 'pointer',
//                           transition: 'all 0.3s ease',
//                         }}
//                         onMouseEnter={(e) => {
//                           e.currentTarget.style.transform = 'translateX(5px)';
//                           e.currentTarget.style.borderColor = stageColor;
//                         }}
//                         onMouseLeave={(e) => {
//                           e.currentTarget.style.transform = 'translateX(0)';
//                           e.currentTarget.style.borderColor =
//                             mode === 'dark' ? '#3d3d5c' : '#e0e0e0';
//                         }}
//                       >
//                         <div className="p-3">
//                           <div className="d-flex align-items-center justify-content-between">
//                             <div className="d-flex align-items-center" style={{ flex: 1 }}>
//                               <div className="me-3">
//                                 {React.cloneElement(
//                                   stagesIcons[stage.stageName] || <AccessibilityNewIcon />,
//                                   {
//                                     sx: { color: stageColor },
//                                   },
//                                 )}
//                               </div>
//                               <div style={{ flex: 1 }}>
//                                 <h6
//                                   className="fw-bold mb-1"
//                                   style={{
//                                     color: mode === 'dark' ? '#fff' : '#333',
//                                     fontSize: '0.9rem',
//                                   }}
//                                 >
//                                   {stage.stageName}
//                                 </h6>
//                                 <div className="d-flex align-items-center">
//                                   <div style={{ flex: 1, marginRight: '10px' }}>
//                                     <div
//                                       style={{
//                                         height: '6px',
//                                         background:
//                                           mode === 'dark'
//                                             ? 'rgba(255,255,255,0.1)'
//                                             : 'rgba(0,0,0,0.1)',
//                                         borderRadius: '3px',
//                                         overflow: 'hidden',
//                                       }}
//                                     >
//                                       <div
//                                         style={{
//                                           width: `${percentage}%`,
//                                           height: '100%',
//                                           background: `linear-gradient(90deg, ${stageColor} 0%, ${stageColor}80 100%)`,
//                                           borderRadius: '3px',
//                                         }}
//                                       />
//                                     </div>
//                                   </div>
//                                   <span
//                                     style={{
//                                       fontSize: '0.8rem',
//                                       color: mode === 'dark' ? '#aaa' : '#666',
//                                       minWidth: '60px',
//                                       textAlign: 'right',
//                                     }}
//                                   >
//                                     {percentage}%
//                                   </span>
//                                 </div>
//                               </div>
//                             </div>

//                             <div className="text-end" style={{ minWidth: '80px' }}>
//                               <div
//                                 style={{
//                                   fontSize: '1.2rem',
//                                   fontWeight: 'bold',
//                                   color: stageColor,
//                                 }}
//                               >
//                                 {stage.leadsCount}
//                               </div>
//                               <small
//                                 style={{
//                                   fontSize: '0.75rem',
//                                   color: mode === 'dark' ? '#aaa' : '#888',
//                                 }}
//                               >
//                                 leads
//                               </small>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               </div>
//             </div>
//           </Col>
//         </Row>

//         {/* 📊 قسم الأداء */}
//         <div
//           className="mt-5 pt-4 border-top"
//           style={{
//             borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//           }}
//         >
//           <DashbordPerformanceForAllUsers darkMode={mode === 'dark'} />
//         </div>
//       </Container>

//       {/* تخصيص Styles */}
//       <style>
//         {`
//           .progress-bar {
//             background-color: ${UNIFIED_COLOR} !important;
//           }
          
//           .stage-card:hover {
//             transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//           }
          
//           .heebo-bold {
//             font-family: 'Heebo', sans-serif;
//             font-weight: 700 !important;
//           }
          
//           .dashboard-card {
//             border-radius: 20px !important;
//             box-shadow: 0 4px 15px rgba(0,0,0,0.1);
//           }
          
//           ::-webkit-scrollbar {
//             width: 6px;
//           }
          
//           ::-webkit-scrollbar-track {
//             background: ${mode === 'dark' ? '#1a1a2e' : '#f1f1f1'};
//             border-radius: 10px;
//           }
          
//           ::-webkit-scrollbar-thumb {
//             background: ${UNIFIED_COLOR};
//             border-radius: 10px;
//           }
          
//           ::-webkit-scrollbar-thumb:hover {
//             background: #4a9ddd;
//           }
          
//           @keyframes fadeInUp {
//             from {
//               opacity: 0;
//               transform: translateY(20px);
//             }
//             to {
//               opacity: 1;
//               transform: translateY(0);
//             }
//           }
          
//           .stage-list-card {
//             animation: fadeInUp 0.3s ease-out;
//           }
          
//           @keyframes loadingPulse {
//             0% { opacity: 1; }
//             50% { opacity: 0.5; }
//             100% { opacity: 1; }
//           }
          
//           .loading-text {
//             animation: loadingPulse 1.5s infinite;
//           }
          
//           /* ✅ جديد: Animations for loading */
//           @keyframes move {
//             0% { background-position: 0 0; }
//             100% { background-position: 20px 0; }
//           }
          
//           @keyframes pulse {
//             0% { transform: scale(1); }
//             50% { transform: scale(1.05); }
//             100% { transform: scale(1); }
//           }
//         `}
//       </style>
//     </div>
//   );
// };



















// 20-5-2026

import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { useTheme, useMediaQuery } from '@mui/material';
import {
  AccessibilityNew as AccessibilityNewIcon,
  TipsAndUpdates as TipsAndUpdatesIcon,
  Bookmark as BookmarkIcon,
  AccessTimeFilled as AccessTimeFilledIcon,
  AccessAlarm as AccessAlarmIcon,
  TaskAlt as TaskAltIcon,
  PhonelinkErase as PhonelinkEraseIcon,
  ThumbUp as ThumbUpIcon,
  Cancel as CancelIcon,
  WorkHistory as WorkHistoryIcon,
  Backspace as BackspaceIcon,
  ShowChart as ShowChartIcon,
  BarChart as BarChartIcon,
  PendingActions as PendingActionsIcon,
  People as PeopleIcon,
} from '@mui/icons-material';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS, ArcElement, Tooltip, Legend,
  CategoryScale, LinearScale, PointElement, LineElement, Title, Filler,
} from 'chart.js';

import { Getteamleaderdashboarddatabyteamleaderemailadvanced } from '../Redux/Actions/RoleData_Actions';
import { DashbordPerformanceForAllUsers } from './DashbordPerformanceForAllUsers';
import { useSidebarWidth } from '../Utility/useSidebarWidth';

ChartJS.register(ArcElement, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

/* ─── Design tokens — same as SalesDashboard ─────────────────────────────── */
const C = {
  bg:         '#F7F8FC',
  white:      '#FFFFFF',
  border:     '#E8EAF0',
  accent:     '#0D47A1',
  accentDark: '#0a3880',
  accentSoft: 'rgba(13,71,161,0.07)',
  text:       '#1C2340',
  textMuted:  '#7B829A',
  warning:    '#F79009',
  shadow:     '0 1px 3px rgba(16,24,40,0.08)',
  shadowMd:   '0 4px 16px rgba(16,24,40,0.10)',
};

const SIDEBAR_COLLAPSED = 64;

/* ─── Stage icons ─────────────────────────────────────────────────────────── */
const STAGE_ICONS = {
  Fresh:                    <TipsAndUpdatesIcon />,
  'No Stage':               <TipsAndUpdatesIcon />,
  'Team Leader Fresh':      <TipsAndUpdatesIcon />,
  'Team Leader Pending':    <PendingActionsIcon />,
  Pending:                  <PendingActionsIcon />,
  Follow:                   <BookmarkIcon />,
  'Follow Up':              <BookmarkIcon />,
  'Long Follow':            <BookmarkIcon />,
  Transfer:                 <BackspaceIcon />,
  Interested:               <ThumbUpIcon />,
  'Not Interested':         <BackspaceIcon />,
  Meeting:                  <AccessTimeFilledIcon />,
  'Following After Meeting':<WorkHistoryIcon />,
  'Follow After Meeting':   <WorkHistoryIcon />,
  'Cancel Meeting':         <CancelIcon />,
  'Done Deal':              <TaskAltIcon />,
  'No Answer':              <PhonelinkEraseIcon />,
  'No Answer 1st Call':     <AccessAlarmIcon />,
  Cancellation:             <CancelIcon />,
};

/* ─── stage colour logic — only #0D47A1 and #F79009 ─────────────────────── */
const getStageColor = (name) => {
  if (name === 'Team Leader Pending' || name === 'Pending') return C.warning;
  return C.accent;
};

/* ─── Stat card ── identical to SalesDashboard ───────────────────────────── */
const StatCard = ({ label, value, sub, highlight, color, onClick }) => {
  const bg   = highlight ? (color || C.accent) : C.white;
  const bdr  = highlight ? (color || C.accent) : C.border;
  const shad = highlight ? `0 4px 16px ${color || C.accent}40` : C.shadow;
  return (
    <div
      onClick={onClick}
      style={{
        background: bg, border: `1px solid ${bdr}`, borderRadius: 12,
        padding: '20px 24px', minWidth: 160, height: 120,
        boxShadow: shad,
        display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
        cursor: onClick ? 'pointer' : 'default', flexShrink: 0,
        transition: 'transform 0.15s, box-shadow 0.15s',
      }}
      onMouseEnter={e => { if (onClick) { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = `0 8px 24px ${color || C.accent}30`; } }}
      onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = shad; }}
    >
      <span style={{ fontSize: 11, fontWeight: 500, color: highlight ? 'rgba(255,255,255,0.75)' : C.textMuted, letterSpacing: '0.06em', textTransform: 'uppercase', fontFamily: "'DM Sans', sans-serif" }}>{label}</span>
      <span style={{ fontSize: 26, fontWeight: 700, color: highlight ? '#fff' : C.text, fontFamily: "'DM Sans', sans-serif", lineHeight: 1.2 }}>{value ?? '—'}</span>
      {sub && <span style={{ fontSize: 11, color: highlight ? 'rgba(255,255,255,0.6)' : C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>{sub}</span>}
      {highlight && <div style={{ height: 3, width: 40, background: '#fff', borderRadius: 2, opacity: 0.4 }} />}
    </div>
  );
};

/* ─── Stage card ── identical shape to SalesDashboard's StageCard ─────────── */
const StageCard = ({ stage, totalLeads, onStageClick }) => {
  const color   = getStageColor(stage.stageName);
  const count   = stage.leadsCount || 0;
  const pct     = totalLeads > 0 ? ((count / totalLeads) * 100).toFixed(1) : 0;
  const icon    = STAGE_ICONS[stage.stageName] || <AccessibilityNewIcon />;
  const isWarm  = color === C.warning; // Pending stages — amber highlight

  return (
    <div
      onClick={() => onStageClick(stage)}
      style={{
        background:  isWarm ? C.warning : C.white,
        border: `1px solid ${isWarm ? C.warning : C.border}`,
        borderRadius: 10, padding: '12px 16px', cursor: 'pointer',
        transition: 'transform 0.15s, box-shadow 0.15s, border-color 0.15s',
        boxShadow: isWarm ? `0 4px 16px rgba(247,144,9,0.30)` : C.shadow,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        gap: 10, minHeight: 70,
      }}
      onMouseEnter={e => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = `0 8px 24px ${color}40`;
        if (!isWarm) e.currentTarget.style.borderColor = color;
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = isWarm ? `0 4px 16px rgba(247,144,9,0.30)` : C.shadow;
        e.currentTarget.style.borderColor = isWarm ? C.warning : C.border;
      }}
    >
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 10, fontWeight: 600, letterSpacing: '0.07em', textTransform: 'uppercase', color: isWarm ? 'rgba(255,255,255,0.85)' : C.textMuted, fontFamily: "'DM Sans', sans-serif", marginBottom: 4, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {stage.stageName}
        </div>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 5 }}>
          <span style={{ fontSize: 24, fontWeight: 800, lineHeight: 1, color: isWarm ? '#fff' : color, fontFamily: "'DM Sans', sans-serif" }}>{count}</span>
          <span style={{ fontSize: 11, fontWeight: 500, color: isWarm ? 'rgba(255,255,255,0.7)' : C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>{pct}%</span>
        </div>
      </div>
      <div style={{ flexShrink: 0, opacity: isWarm ? 0.9 : 0.55, display: 'flex', alignItems: 'center' }}>
        {React.cloneElement(icon, { sx: { color: isWarm ? '#fff' : color, fontSize: 22 } })}
      </div>
    </div>
  );
};

/* ─── Stage list row ── identical to SalesDashboard's StageRow ───────────── */
const StageRow = ({ stage, totalLeads, onStageClick }) => {
  const color = getStageColor(stage.stageName);
  const count = stage.leadsCount || 0;
  const pct   = totalLeads > 0 ? ((count / totalLeads) * 100).toFixed(1) : 0;
  const icon  = STAGE_ICONS[stage.stageName] || <AccessibilityNewIcon />;

  return (
    <div
      onClick={() => onStageClick(stage)}
      style={{
        display: 'flex', alignItems: 'center', gap: 12,
        padding: '12px 16px', background: C.white,
        border: `1px solid ${C.border}`, borderRadius: 10,
        cursor: 'pointer', marginBottom: 8,
        transition: 'transform 0.15s, border-color 0.15s',
      }}
      onMouseEnter={e => { e.currentTarget.style.transform = 'translateX(4px)'; e.currentTarget.style.borderColor = color; }}
      onMouseLeave={e => { e.currentTarget.style.transform = 'translateX(0)'; e.currentTarget.style.borderColor = C.border; }}
    >
      <div style={{ width: 34, height: 34, borderRadius: 8, background: color + '12', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
        {React.cloneElement(icon, { sx: { color, fontSize: 18 } })}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: C.text, fontFamily: "'DM Sans', sans-serif", marginBottom: 5 }}>{stage.stageName}</div>
        <div style={{ height: 4, background: C.border, borderRadius: 2, overflow: 'hidden' }}>
          <div style={{ width: `${pct}%`, height: '100%', background: color, borderRadius: 2 }} />
        </div>
      </div>
      <div style={{ textAlign: 'right', flexShrink: 0 }}>
        <div style={{ fontSize: 16, fontWeight: 700, color, fontFamily: "'DM Sans', sans-serif" }}>{count}</div>
        <div style={{ fontSize: 11, color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>{pct}%</div>
      </div>
    </div>
  );
};

/* ════════════════════════════════════════════════════════════════════════════
   MAIN
════════════════════════════════════════════════════════════════════════════ */
export const TeamLeaderDashboard = () => {
  const theme    = useTheme();
  const mode     = theme.palette.mode;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sidebarW = useSidebarWidth();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [userlogin, setUserlogin] = useState(null);
  const [loading,   setLoading]   = useState(true);

  useEffect(() => {
    const u = localStorage.getItem('user');
    if (u) setUserlogin(JSON.parse(u));
  }, []);

  const dashboardData     = useSelector(s => s.AllRoleData.teamleaderdashboard);
  const dashboard         = dashboardData?.data?.dashboard         || [];
  const teamLeaderFresh   = dashboardData?.data?.teamLeaderFresh   || { leadsCount: 0 };
  const teamLeaderPending = dashboardData?.data?.teamLeaderPending || { leadsCount: 0, salesIds: [] };
  const summary           = dashboardData?.data?.summary           || { totalLeads: 0 };
  const teamleaderInfo    = dashboardData?.data?.teamleaderInfo    || {};

  useEffect(() => {
    if (userlogin?.data?.email) {
      setLoading(true);
      dispatch(Getteamleaderdashboarddatabyteamleaderemailadvanced(userlogin.data.email))
        .finally(() => setLoading(false));
    }
  }, [userlogin, dispatch]);

  useEffect(() => { if (dashboardData) setLoading(false); }, [dashboardData]);

  /* ── sorted stages ── */
  const STAGE_ORDER = ['Team Leader Pending','Team Leader Fresh','No Stage','Pending','Interested','Follow Up','Meeting','Follow After Meeting','Done Deal','Cancel Meeting','No Answer','Not Interested','Transfer','Long Follow','Follow','Following After Meeting','No Answer 1st Call','Cancellation'];

  const allStages = useMemo(() => {
    const regular = dashboard
      .filter(s => s.stageName !== 'Fresh' && s.stageName !== 'Team Leader Fresh' && s.stageName !== 'Team Leader Pending')
      .sort((a, b) => {
        const ia = STAGE_ORDER.indexOf(a.stageName), ib = STAGE_ORDER.indexOf(b.stageName);
        if (ia !== -1 && ib !== -1) return ia - ib;
        if (ia !== -1) return -1; if (ib !== -1) return 1; return 0;
      });

    return [
      { stageId: 'tl-pending', stageName: 'Team Leader Pending', leadsCount: teamLeaderPending.leadsCount, isTeamLeaderPending: true, salesIds: teamLeaderPending.salesIds || [] },
      { stageId: 'tl-fresh',   stageName: 'Team Leader Fresh',   leadsCount: teamLeaderFresh.leadsCount,   isTeamLeaderFresh: true },
      ...regular,
    ];
  }, [dashboard, teamLeaderFresh, teamLeaderPending]);

  const totalLeads = summary.totalLeads || 0;
  const doneDeals  = allStages.find(s => s.stageName === 'Done Deal')?.leadsCount || 0;
  const convRate   = totalLeads > 0 ? ((doneDeals / totalLeads) * 100).toFixed(1) : 0;

  /* ── stage click ── */
  const handleStageClick = async (stage) => {
    const keys = ['teamLeaderFreshMode','teamLeaderPendingMode','teamLeaderPendingSalesId','teamleaderfresh','teamleaderId','filterForSales','teamleaderpending','stagestorage','FilteredLeadsForNoStage','FilteredLeadsForTeamLeaderPending','freshFilterType'];
    keys.forEach(k => localStorage.removeItem(k));

    const { stageName, isTeamLeaderFresh, isTeamLeaderPending, salesIds } = stage;

    if (isTeamLeaderFresh) {
      const tlId = salesIds?.[0] || teamleaderInfo._id || userlogin?.data?._id || '';
      const q = new URLSearchParams({ stage: 'No Stage', sales: tlId, teamleaderfresh: 'true', freshmode: 'teamleader' });
      localStorage.setItem('stagestorage', 'No Stage');
      localStorage.setItem('filterForSales', tlId);
      localStorage.setItem('teamleaderId', tlId);
      localStorage.setItem('teamleaderfresh', 'true');
      localStorage.setItem('teamLeaderFreshMode', 'true');
      localStorage.setItem('freshFilterType', 'teamleader');
      navigate(`/AllLeadsForTeamLeader?${q.toString()}`);

    } else if (isTeamLeaderPending) {
      const tlId = salesIds?.[0] || teamleaderInfo._id || userlogin?.data?._id || '';
      const q = new URLSearchParams({ stage: 'Pending', sales: tlId, teamleaderpending: 'true', pendingmode: 'teamleader' });
      localStorage.setItem('stagestorage', 'Pending');
      localStorage.setItem('teamleaderpending', 'true');
      localStorage.setItem('filterForSales', tlId);
      localStorage.setItem('teamLeaderPendingMode', 'true');
      localStorage.setItem('teamLeaderPendingSalesId', tlId);
      navigate(`/AllLeadsForTeamLeader?${q.toString()}`);

    } else if (stageName === 'All Leads') {
      localStorage.setItem('stagestorage', '');
      navigate('/AllLeadsForTeamLeader');

    } else {
      localStorage.setItem('stagestorage', stageName);
      const suffix = stageName === 'No Stage' ? '&mode=all' : '';
      navigate(`/AllLeadsForTeamLeader?stage=${encodeURIComponent(stageName)}${suffix}`);
    }
  };

  /* ── chart ── */
  const chartData = useMemo(() => {
    const labels = allStages.map(s => s.stageName);
    const data   = allStages.map(s => s.leadsCount || 0);
    const colors = allStages.map(s => getStageColor(s.stageName));
    return {
      labels,
      datasets: [{ data, backgroundColor: colors, borderColor: mode === 'dark' ? '#1a1a2e' : '#fff', borderWidth: 2, hoverOffset: 12 }],
    };
  }, [allStages, mode]);

  const chartOptions = {
    responsive: true, maintainAspectRatio: false,
    plugins: {
      legend: { position: 'right', labels: { color: mode === 'dark' ? '#fff' : C.text, font: { size: 11, family: "'DM Sans', sans-serif" }, padding: 16, usePointStyle: true, pointStyle: 'circle' } },
      tooltip: {
        backgroundColor: C.white, titleColor: C.text, bodyColor: C.textMuted, borderColor: C.border, borderWidth: 1,
        callbacks: { label: ctx => { const t = ctx.dataset.data.reduce((a,b)=>a+b,0); return `${ctx.label}: ${ctx.raw} leads (${t>0?((ctx.raw/t)*100).toFixed(1):0}%)`; } },
      },
    },
    cutout: '62%',
  };

  /* ── loading ── */
  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', background: C.bg }}>
      <div style={{ textAlign:'center' }}>
        <div style={{ width:48, height:48, borderRadius:'50%', border:`3px solid ${C.accentSoft}`, borderTop:`3px solid ${C.accent}`, animation:'spin 0.8s linear infinite', margin:'0 auto 16px' }} />
        <div style={{ fontSize:14, color:C.textMuted, fontFamily:"'DM Sans', sans-serif" }}>Loading Dashboard...</div>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );

  /* ── render ── */
  return (
    <div style={{
      marginLeft: isMobile ? SIDEBAR_COLLAPSED : sidebarW,
      marginTop: 64,
      minHeight: 'calc(100vh - 64px)',
      background: C.bg,
      transition: 'margin-left 0.25s cubic-bezier(0.4,0,0.2,1)',
      fontFamily: "'DM Sans', sans-serif",
    }}>
      <div style={{ padding: isMobile ? '16px' : '28px 28px 48px' }}>

        {/* ── Header ── */}
        <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', flexWrap:'wrap', gap:16, marginBottom:28 }}>
          <div>
            <div style={{ fontSize: isMobile ? 28 : 36, fontWeight:800, color:C.text, lineHeight:1.15, letterSpacing:'-0.02em', fontFamily:"'DM Sans', sans-serif" }}>
              Team Leader<br />Dashboard
            </div>
            <div style={{ fontSize:13.5, color:C.textMuted, marginTop:8, fontFamily:"'DM Sans', sans-serif" }}>
              Welcome back, <strong style={{ color:C.text }}>{teamleaderInfo.name || userlogin?.data?.name || 'Team Leader'}</strong> — manage your team's pipeline.
              {dashboardData?.data?.meta && (
                <span style={{ marginLeft:8, fontSize:11, color:C.textMuted }}>
                  · {dashboardData.data.meta.executionTime} {dashboardData.data.meta.fromCache ? '(cached)' : '(fresh)'}
                </span>
              )}
            </div>
          </div>

          {/* Stat cards row */}
          <div style={{ display:'flex', gap:12, flexWrap:'wrap', alignItems:'stretch' }}>
            <StatCard label="All Leads"   value={totalLeads}                   onClick={() => handleStageClick({ stageName:'All Leads' })} />
            <StatCard label="TL Pending"  value={teamLeaderPending.leadsCount} color={C.warning} highlight onClick={() => handleStageClick({ stageName:'Team Leader Pending', isTeamLeaderPending:true, salesIds:teamLeaderPending.salesIds })} />
            <StatCard label="TL Fresh"    value={teamLeaderFresh.leadsCount}   color={C.accent}  highlight onClick={() => handleStageClick({ stageName:'Team Leader Fresh', isTeamLeaderFresh:true })} />
            <StatCard label="Conv. Rate"  value={`${convRate}%`} highlight />
          </div>
        </div>

        {/* ── Toolbar ── */}
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20, flexWrap:'wrap', gap:8 }}>
          <div style={{ display:'flex', alignItems:'center', gap:8 }}>
            <ShowChartIcon sx={{ color:C.accent, fontSize:18 }} />
            <span style={{ fontSize:16, fontWeight:700, color:C.text, fontFamily:"'DM Sans', sans-serif" }}>All Stages</span>
            <span style={{ fontSize:12, color:C.textMuted, fontFamily:"'DM Sans', sans-serif" }}>({allStages.length}) — click any card to view leads</span>
          </div>
          <Link to="/TeamLeaderQuickNumbersCRMData" style={{ textDecoration:'none' }}>
            <button
              style={{ display:'flex', alignItems:'center', gap:6, padding:'7px 14px', borderRadius:8, border:`1px solid ${C.border}`, background:C.white, color:C.text, fontSize:13, fontWeight:600, cursor:'pointer', fontFamily:"'DM Sans', sans-serif", transition:'all 0.15s' }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = C.accent; e.currentTarget.style.color = C.accent; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.color = C.text; }}
            >
              <ContactMailIcon sx={{ fontSize:16 }} />
              CRM Data
            </button>
          </Link>
        </div>

        {/* ── Stage cards grid ── */}
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(160px, 1fr))', gap:12, marginBottom:28 }}>
          {allStages.map(stage => (
            <StageCard
              key={stage.stageId || stage.stageName}
              stage={stage}
              totalLeads={totalLeads}
              onStageClick={handleStageClick}
            />
          ))}
        </div>

        {/* ── Chart + List row ── */}
        <div style={{ display:'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap:16, marginBottom:28 }}>

          {/* Doughnut */}
          <div style={{ background:C.white, border:`1px solid ${C.border}`, borderRadius:12, boxShadow:C.shadow, overflow:'hidden' }}>
            <div style={{ padding:'20px 22px 16px', borderBottom:`1px solid ${C.border}` }}>
              <div style={{ fontSize:15, fontWeight:700, color:C.text, fontFamily:"'DM Sans', sans-serif" }}>
                <BarChartIcon sx={{ fontSize:17, color:C.accent, verticalAlign:'middle', mr:0.5 }} />
                Leads Distribution
              </div>
              <div style={{ fontSize:12, color:C.textMuted, fontFamily:"'DM Sans', sans-serif", marginTop:3 }}>Visual breakdown across all stages</div>
            </div>
            <div style={{ padding:'20px 22px', height:320 }}>
              <Doughnut data={chartData} options={chartOptions} />
            </div>
          </div>

          {/* Stages list */}
          <div style={{ background:C.white, border:`1px solid ${C.border}`, borderRadius:12, boxShadow:C.shadow, overflow:'hidden' }}>
            <div style={{ padding:'20px 22px 16px', borderBottom:`1px solid ${C.border}` }}>
              <div style={{ fontSize:15, fontWeight:700, color:C.text, fontFamily:"'DM Sans', sans-serif" }}>
                <BookmarkIcon sx={{ fontSize:17, color:C.accent, verticalAlign:'middle', mr:0.5 }} />
                Stages Overview
              </div>
              <div style={{ fontSize:12, color:C.textMuted, fontFamily:"'DM Sans', sans-serif", marginTop:3 }}>Click any stage to view its leads</div>
            </div>
            <div style={{ padding:'16px 22px', maxHeight:320, overflowY:'auto' }}>
              {allStages.map(stage => (
                <StageRow
                  key={stage.stageId || stage.stageName}
                  stage={stage}
                  totalLeads={totalLeads}
                  onStageClick={handleStageClick}
                />
              ))}
            </div>
          </div>
        </div>

        {/* ── Performance ── */}
        <div style={{ background:C.white, border:`1px solid ${C.border}`, borderRadius:12, boxShadow:C.shadow, overflow:'hidden' }}>
          <div style={{ padding:'20px 22px 16px', borderBottom:`1px solid ${C.border}` }}>
            <div style={{ fontSize:15, fontWeight:700, color:C.text, fontFamily:"'DM Sans', sans-serif" }}>Performance Analytics</div>
            <div style={{ fontSize:12, color:C.textMuted, fontFamily:"'DM Sans', sans-serif", marginTop:3 }}>Team activity and conversion metrics</div>
          </div>
          <div style={{ padding:'20px 22px' }}>
            <DashbordPerformanceForAllUsers darkMode={mode === 'dark'} />
          </div>
        </div>

      </div>
    </div>
  );
};
